export default __webpack_public_path__ + "static/logo-white-df258be6832cdafe15e1624ffa25c79f.png";